<svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect opacity="0.1" width="6" height="6" rx="3" [attr.fill]="color"/>
</svg>
